"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialInteraction = void 0;
var socialInteraction = function (event) {
    return {
        event: 'social-interaction',
        eventInfo: 'social-interaction',
        action: 'social-interaction',
        socialTool: event.eventData.socialTool,
    };
};
exports.socialInteraction = socialInteraction;
